// What a backup file carries (Implementation Plan v02 §6.4; IP2-37; I-1a Batch 6b).
//
// - Every record of the open diary (the personal space — the practice space does
//   not exist yet), drafts included: a backup is a full restore to another
//   phone, not an export view (IP2-37; D-68's "never in exports" covers JSON /
//   CSV / PDF).
// - NOT the activity log ("No activity log", §6.4): records of kind `activity`
//   stay on this phone.
// - Photo blobs only when a carried record links to them, still sealed under
//   their own photo keys. An orphan blob (its moment is gone, so it is already
//   unreadable) is never carried to the other phone.
// - Records this phone could not open are skipped by the store (and counted for
//   the diagnostic export); they cannot be carried.

import type { EncryptedStore } from '../store'

import type { BackupContents } from './backupFile'

/** Record kinds that never go into a backup file. */
export const NOT_IN_BACKUP: ReadonlySet<string> = new Set(['activity'])

export async function collectBackupContents(store: EncryptedStore): Promise<BackupContents> {
  const records = store.list().filter((record) => !NOT_IN_BACKUP.has(record.kind))
  const linked = new Set<string>()
  for (const record of records) {
    for (const blobId of record.links?.blobs ?? []) {
      linked.add(blobId)
    }
  }
  const blobs = (await store.sealedBlobs([...linked])).map((sealed) => ({
    id: sealed.id,
    schemaVersion: sealed.schemaVersion,
    iv: sealed.iv,
    ct: sealed.ct,
  }))
  return { records, blobs }
}
